type AnyFunction<T> = (...args: T[]) => any;

function bindTrailingArgs<T>(fn: AnyFunction<T>, ...boundArgs: T[]) {
    return (...args: T[]) => {
        return fn(...args, ...boundArgs);
    };
}

export default bindTrailingArgs;
